export default __webpack_public_path__ + "static/media/033.0035b5e7.webp";